import { Vector2 } from "three";
export var UniformName = /* @__PURE__ */ ((UniformName2) => {
  UniformName2["TIME"] = "time";
  UniformName2["RESOLUTION"] = "resolution";
  return UniformName2;
})(UniformName || {});
const GLOBAL_UNIFORMS = {
  ["resolution" /* RESOLUTION */]: { value: new Vector2(1e3, 1e3) }
};
export class UniformsController {
  constructor(scene) {
    this.scene = scene;
  }
  addUniforms(uniforms, options) {
    const { paramConfigs, additionalTextureUniforms, timeDependent, resolutionDependent } = options;
    for (let paramConfig of paramConfigs) {
      uniforms[paramConfig.uniformName()] = paramConfig.uniform();
    }
    const additionalUniformNames = Object.keys(additionalTextureUniforms);
    for (let uniformName of additionalUniformNames) {
      const uniformValue = additionalTextureUniforms[uniformName];
      uniforms[uniformName] = uniformValue;
    }
    if (timeDependent) {
      this.addTimeUniform(uniforms);
    } else {
      this.removeTimeUniform(uniforms);
    }
    if (resolutionDependent) {
      this.addResolutionUniforms(uniforms);
    } else {
      this.removeResolutionUniform(uniforms);
    }
  }
  addTimeUniform(uniforms) {
    uniforms["time" /* TIME */] = this.scene.timeController.timeUniform();
  }
  removeTimeUniform(uniforms) {
    delete uniforms["time" /* TIME */];
  }
  timeUniformValue() {
    return this.scene.timeController.timeUniform().value;
  }
  addResolutionUniforms(uniforms) {
    uniforms["resolution" /* RESOLUTION */] = GLOBAL_UNIFORMS["resolution" /* RESOLUTION */];
  }
  removeResolutionUniform(uniforms) {
    delete uniforms["resolution" /* RESOLUTION */];
  }
  updateResolution(resolution) {
    GLOBAL_UNIFORMS["resolution" /* RESOLUTION */].value.copy(resolution);
  }
}
